<template>
    <div class="c-form-wrap" v-bind:class="ComputedClass">
        <label class="c-form-wrap__field-name">{{label}}</label>

        <div class="c-form-wrap__field-wrap">
            <div class="c-form-wrap__input-wrap">
                <input class="c-form-wrap__input"
                       v-model="localValue"
                       @focus="focus"
                       @focusout="focusOut"
                       :name="fieldName"
                       :type="type"
                       ref="input"
                       v-validate="validation"
                       :data-vv-name="fieldName"

                       :disabled="isApprove"
                       v-mask="mask"
                       v-if="mask"
                >
                <input class="c-form-wrap__input"
                       v-model="localValue"
                       @focus="focus"
                       @focusout="focusOut"
                       :name="fieldName"
                       v-validate="validation"
                       :data-vv-name="fieldName"

                       :type="type"
                       :disabled="isApprove"
                       v-else>
            </div>
            <span v-if="showPlaceholder" class="c-form-wrap__input-placeholder">{{placehoderMask}}</span>
        </div>

        <span class="c-form-wrap__tooltip">
            <span class="c-form-wrap__hidden">
                <template v-if="isError && !focusField">
                        {{ errors.first(fieldName)}}
                </template>
                <template v-else>
                    <slot name="hint"></slot>
                </template>
            </span>
            <slot name="tooltip"></slot>
        </span>
    </div>
</template>

<script>
    import {STATUSES} from "../statuses";

    export default {
        name: "cInput",
        inject: ['$validator'],
        props: {
            value: {},
            label: {
                default: "Заголовок"
            },
            mask: {
                default: null
            },
            type: {
                default: "text"
            },
            validation: {
                default: null
            },
            fieldName: {
                required: true
            },
            hint: {},
            externalError: {
                type: Object,
                default: function () {
                    return {
                        haveError: false,
                        errorText: ""
                    };
                }
            },
            externalStatus: {
                default: STATUSES.EMPTY
            }
        },
        data() {
            return {
                localValue: this.value,
                status: STATUSES.EMPTY,
                isEdit: false,
                focusField: false
            };
        },
        watch: {
            value(newVal, oldVal) {
                if (newVal !== oldVal) {
                    this.localValue = newVal;
                }
            },
            localValue(newVal, oldVal) {
                if (newVal !== oldVal) {
                    this.$emit("input", newVal);
                }

                if (this.localValue.length === 0) {
                    this.status = STATUSES.EMPTY;
                } else {
                    this.status = STATUSES.FILLED;
                }
            }
        },
        methods: {
            onChange(evt) {
                this.localValue = evt.target.value;
                this.$emit("change", this.localValue);
            },
            focus(evt) {
                this.status = STATUSES.FOCUS;
                this.focusField = true;
                if (this.isEmpty) {
                    if (this.mask) {
                        if (this.mask.indexOf("#") > -1) {
                            this.localValue = this.mask.split("#")[0];
                        } else if (this.mask.indexOf("X") > -1) {
                            this.localValue = this.mask.split("X")[0];
                        }
                    }
                }
                if (this.externalStatus === STATUSES.COMPLETE) {
                    this.isEdit = true;
                }
            },
            focusOut(evt) {
                if (this.isEmpty) {
                    this.status = STATUSES.EMPTY;
                } else {
                    this.status = STATUSES.FILLED;
                }
                this.focusField = false;
                if (this.externalStatus === STATUSES.COMPLETE) {
                    this.isEdit = false;
                }
            }
        },
        computed: {
            isEmpty() {
                return this.localValue.length === 0;
            },
            isFocus() {
                return this.status === STATUSES.FOCUS;
            },
            isFilled() {
                return !this.isEmpty;
            },
            isError() {
                return this.errors.has(this.fieldName) || this.externalError.haveError;
            },
            isComplete() {
                return this.externalStatus === STATUSES.COMPLETE && !this.isEdit;
            },
            isApprove() {
                return this.externalStatus === STATUSES.APPROVE;
            },
            ComputedClass: function () {
                return {
                    "c-form-wrap--empty": this.isEmpty,
                    "c-form-wrap--focus": this.isFocus,
                    "c-form-wrap--filled": this.isFilled,
                    "c-form-wrap--error": this.isError,

                    "c-form-wrap--complete": this.isComplete,
                    "c-form-wrap--approve": this.isApprove
                };
            },
            // Заменить все спецсимволы маски на _, а потом по мере заполнения заменять на то что введено
            placehoderMask: function () {
                if (this.mask) {
                    let placeholder = this.mask.replace(/[XSAa!R/*#]/g, "_");
                    return (
                        this.localValue +
                        placeholder.substring(this.localValue.length, placeholder.length)
                    );
                }
            },
            showPlaceholder: function () {
                return (this.mask && this.isFilled) || this.isFocus;
            }
        }
    };
</script>

<style lang="scss">
    @import "~@/assets/scss/variable";

    .c-form-wrap {
        box-sizing: border-box;
        margin: 0 10px 10px;
        text-align: left;
        font-family: $RobotoRegular;
        position: relative;
        &__field-name {
            padding-left: 10px;
            display: block;
            position: absolute;
            font-size: 14px;
            transform: translateY(-50%);
            transition: all ease 0.1s;
            top: 28px;
            line-height: 1.2;
            color: #4a4a4a;
        }
        &__input-wrap {
            position: relative;
            vertical-align: top;
            &::before {
                left: 0;
                content: "";
                height: 1px;
                position: absolute;
                bottom: 0;
                width: 100%;
                z-index: 20;
                background: #979797;
            }
            &::after {
                left: 0;
                content: "";
                height: 2px;
                position: absolute;
                bottom: 0;
                width: 0;
                transition: all ease 0.3s;
                z-index: 21;
                background: $violet;
            }
        }
        &__input {
            background-color: rgba(255, 183, 0, 0.04);
            border: none;
            width: 100%;
            max-width: 100%;
            box-sizing: border-box;
            font-family: $RobotoRegular;
            font-size: 14px;
            padding: 25px 10px 10px 10px;
        }
        &__input-placeholder {
            position: absolute;
            font-size: 14px;
            font-family: $RobotoRegular;
            top: 25px;
            left: 10px;
        }
        &__tooltip {
            margin-top: 10px;
            font-size: 12px;
            color: #9b9b9b;
            padding-left: 10px;
            line-height: 1.5;
            display: block;
            max-width: 100%;
            width: 100%;
        }
        &__hidden {
            font-size: inherit;
            color: inherit;
        }
    }

    .c-form-wrap {
        $blockname: &;
        &.c-form-wrap--empty {
        }

        &.c-form-wrap--focus {
            #{$blockname}__field-name {
                padding-left: 10px;
                display: block;
                position: absolute;
                font-size: 14px;
                transform: translateY(-50%);
                top: 15px;
                transition: all ease 0.08s;
                line-height: 1.2;
                color: $violet;
            }
            #{$blockname}__input-wrap {
                position: relative;
                &::after {
                    left: 0;
                    content: "";
                    height: 2px;
                    position: absolute;
                    bottom: 0;
                    width: 100%;
                    transition: all ease 0.3s;
                    z-index: 21;
                    background: $violet;
                }
            }
        }
        &.c-form-wrap--filled {
            #{$blockname}__field-name {
                padding-left: 10px;
                display: block;
                position: absolute;
                font-size: 14px;
                transform: translateY(-50%);
                top: 15px;
                transition: all ease 0.08s;
                line-height: 1.2;
                color: $violet;
            }
            #{$blockname}__input-wrap {
                position: relative;
                &::after {
                    left: 0;
                    content: "";
                    height: 2px;
                    position: absolute;
                    bottom: 0;
                    width: 100%;
                    transition: all ease 0.3s;
                    z-index: 21;
                    background: $violet;
                }
            }
        }

        &.c-form-wrap--error {
            #{$blockname}__field-name {
                color: $error;
            }
            #{$blockname}__input-wrap {
                &::after {
                    width: 100%;
                    background: $error;
                }
            }
            #{$blockname}__input {
                background-color: rgba(255, 78, 0, 0.12);
            }
            #{$blockname}__tooltip {
                color: $error;
            }
        }

        &.c-form-wrap--complete {
            #{$blockname}__field-name {
                padding-left: 10px;
                display: block;
                position: absolute;
                font-size: 14px;
                transform: translateY(-50%);
                top: 16px;
                z-index: 21;
                transition: all ease 0.08s;
                line-height: 1.2;
                color: #9b9b9b;
            }
            #{$blockname}__input-wrap {
                position: relative;

                &::before {
                    left: 0;
                    content: "";
                    height: 1px;
                    position: absolute;
                    bottom: 0;
                    width: 100%;
                    z-index: 20;
                    background: #979797;
                }
                &::after {
                    left: 0;
                    content: "";
                    height: 2px;
                    position: absolute;
                    bottom: 0;
                    width: 0;
                    transition: all ease 0.3s;
                    z-index: 21;
                    background: $violet;
                }
            }
            #{$blockname}__input {
                background-color: #ffffff;
                color: $yellow-1;
                font-size: 14px;
                transition: all ease 0.3s;
                text-decoration: underline;
                text-align: right;
                padding: 5px 10px;
            }

            #{$blockname}__input-wrap--button {
                display: inline-block;
                max-width: 100%;
                width: 100%;
                transition: 0.3s ease width;
            }
            #{$blockname}__button {
                display: none;
            }
            #{$blockname}__hidden {
                display: none;
            }
        }
        &.c-form-wrap--complete {
            #{$blockname}__input-placeholder {
                display: none;
            }
        }
        &.c-form-wrap--approve {
            #{$blockname}__field-name {
                padding-left: 10px;
                display: block;
                position: absolute;
                font-size: 14px;
                transform: translateY(-50%);
                top: 16px;
                z-index: 21;
                transition: all ease 0.08s;
                line-height: 1.2;
                color: #9b9b9b;
            }
            #{$blockname}__input-wrap {
                position: relative;

                &::before {
                    left: 0;
                    content: "";
                    height: 1px;
                    position: absolute;
                    bottom: 0;
                    width: 100%;
                    z-index: 20;
                    background: #979797;
                }
                &::after {
                    width: 0;
                }
            }
            #{$blockname}__input-placeholder {
                display: none;
            }
            #{$blockname}__input {
                background-color: #ffffff;
                color: #9b9b9b;
                font-size: 14px;
                padding: 5px 10px;
                transition: all ease 0.3s;
                text-decoration: none;
                text-align: right;
            }
            #{$blockname}__button {
                display: none;
            }
            #{$blockname}__hidden {
                display: none;
            }
        }
    }
</style>
